var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9995 4.97607H15.0386C15.6491 4.97607 16.1422 5.47219 16.1422 6.08643V14.9693C16.1422 15.8907 15.3986 16.6427 14.4789 16.6427V16.6388H6.13107C5.21527 16.6388 4.47559 15.8946 4.47559 14.9732V13.4999",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1459 13.3053H2.79806C1.88226 13.3053 1.14258 12.5611 1.14258 11.6397V2.75294C1.14258 2.1387 1.6357 1.64258 2.24623 1.64258H11.7056C12.3161 1.64258 12.8092 2.1387 12.8092 2.75294V11.6358C12.8092 12.5572 12.0656 13.3092 11.1459 13.3092V13.3053Z",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97559 4.97607V9.97606",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47559 7.47607L4.4756 7.47607",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/Duplicate.0f71f7adca6cb0a952979d06adbecfce.svg";
export { ForwardRef as ReactComponent };